export var DEPLOY_DATE = new Date('2026-03-02T22:45:29+0000');
